import React, {useMemo} from "react";
import {
  Spinner
} from 'reactstrap';

import { usePublicPlaylistList } from '../../api/hooks/public-templates'
import { PublicTemplatesFolderContainer } from "./TemplateCatalog";


export function PlaylistCatalog() {
  const params = useMemo(() => ({
    perPage: 20,
    page: 1,
    jurisdiction: 'mx',
    populate: 'relatedDocuments',
    search: '',
    searchExact: false,
    onlyTemplates: false,
    isPlaylist: false,
    sortBy: 'updatedAt'
  }), [])
  const { data, isLoading } = usePublicPlaylistList(params);

  return (
      <div style={{minHeight: 3 * 300}}>
        {
          data?.data.map(playlist => (
            <PublicTemplatesFolderContainer 
              label={playlist.name}
              type={playlist.type}
              sortBy="updatedAt"
              stripeId={playlist.stripeId}
              stripeInfo={playlist.stripeInfo}
              templateList={playlist.publicTemplateList}
            />
          ))
        }
        {
          isLoading && 
          <div className="w-100 d-flex align-items-center justify-content-center p-4">
            <Spinner />
          </div>
        }
      </div>
  )
}
